import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { IMainTableColumn } from "components/MainTable/MainTableInterfaces";
import { IIssue } from "entities/RCA/IssueEntity/IIssueEntityInterfaces";
import IssueDescriptionCell from "pages/Corporate/RCA/RCAIssues/useRCAIssuesColumns/components/IssueDescriptionCell";
import IssueDueDateCell from "pages/Corporate/RCA/RCAIssues/useRCAIssuesColumns/components/IssueDueDateCell";
import IssueStatusCell from "pages/Corporate/RCA/RCAIssues/useRCAIssuesColumns/components/IssueStatusCell";
import IssueNumberCell from "pages/Corporate/RCA/RCAIssues/useRCAIssuesColumns/components/IssueNumberCell";

interface IMyIssuesColumns extends Omit<IMainTableColumn, "render" | "renderExpandedRow"> {
    render: (row: IIssue) => string | JSX.Element | number;
}

const useMyIssuesColumns = (): IMyIssuesColumns[] => {
    const { t } = useTranslation();

    const columns = useMemo(
        (): IMyIssuesColumns[] => [
            {
                id: "number",
                label: t("rca.issues.number"),
                hideSortIcon: false,
                customStyles: { width: "20%" },
                render: (row) => <IssueNumberCell issue={row} />,
            },
            {
                id: "description",
                label: t("rca.issues.description"),
                hideSortIcon: false,
                customStyles: { width: "40%" },
                render: (row) => <IssueDescriptionCell issue={row} />,
            },
            {
                id: "due_date",
                label: t("rca.issues.due_date"),
                hideSortIcon: false,
                align: "center",
                customStyles: { width: "20%" },
                render: (row) => <IssueDueDateCell issue={row} />,
            },
            {
                id: "status",
                label: t("rca.issues.status"),
                headerCustomStyles: { textAlign: "right", paddingRight: "80px" },
                hideSortIcon: false,
                customStyles: { width: "20%" },
                render: (row) => <IssueStatusCell myDashboard issue={row} />,
            },
        ],
        [t],
    );

    return columns;
};

export default useMyIssuesColumns;
